import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon';
import { IconMap } from '../../sprite';
import { Link } from '../Link';
import { environment } from '../../../environments/environment';

type Props = {
  classNameContent?: string;
  children: ReactNode;
};

export const SignUpLayout: FC<Props> = ({ children, classNameContent }) => {
  return (
    <div className="bg-bg-100 relative min-h-screen overflow-hidden flex items-stretch">
      <div className="flex flex-col w-1/2 md:w-full min-h-screen items-center bg-repeat bg-base-white">
        <div className="flex self-stretch pt-8 px-8 relative z-10">
          <Link
            target="_blank"
            rel="noreferrer"
            href={environment.landingUrl}
            size="medium"
          >
            <Icon glyph={IconMap.DistributeLogo} />
          </Link>
        </div>
        <div
          className={classNames(
            'w-110 pt-16 pb-8 flex justify-center flex-col sm:px-4 sm:w-full',
            classNameContent
          )}
        >
          {children}
        </div>
      </div>
      <div className="w-1/2 bg-auth-noise min-h-screen relative md:hidden">
        <div className="absolute left-0 top-0 pointer-events-none">
          <img
            src="../../../assets/images/signup-left-bg.svg"
            alt="Auth left img"
            className="w-full md:hidden"
          />
        </div>
        <div className="absolute right-0 bottom-0 pointer-events-none">
          <img
            src="../../../assets/images/signup-right-bg.svg"
            alt="Auth left img"
            className="w-full md:hidden"
          />
        </div>
        <div className="absolute left-1/2 pointer-events-none top-1/2 -translate-x-1/2 -translate-y-1/2 w-112">
          <CommentV2 />
        </div>
      </div>
    </div>
  );
};

const CommentV2 = () => {
  return (
    <div className="text-base bg-base-white relative rounded-2xl p-8 flex flex-col gap-4 shadow-lg">
      <div className="flex flex-nowrap items-center gap-2">
        <img
          alt="Heather Bell"
          className="w-12 h-12 rounded-full"
          src="../../../assets/images/heather-bell.jpg"
        />
        <div className="flex flex-col gap-0.5">
          <p className="text-md font-semibold text-gray-900">Heather Bell</p>
          <p className="text-sm text-gray-600">VP of Sales</p>
        </div>
      </div>
      <div className="flex flex-nowrap gap-1">
        <Icon glyph={IconMap.StarFilled} width={20} />
        <Icon glyph={IconMap.StarFilled} width={20} />
        <Icon glyph={IconMap.StarFilled} width={20} />
        <Icon glyph={IconMap.StarFilled} width={20} />
        <Icon glyph={IconMap.StarFilled} width={20} />
      </div>
      <p className="text-xl text-gray-700">
        <span className="font-normal">
          My team was drowning in post-call admin work. Now we create
        </span>
        <span className="font-bold text-gray-900">
          {' '}
          executive-ready digital sales rooms in minutes instead of hours
        </span>
        <span className="font-normal">{`. Our `}</span>
        <span className="font-bold text-gray-900">
          deal velocity has increased 40%
        </span>
        <span className="font-normal"> since implementing Distribute.</span>
      </p>
    </div>
  );
};
